import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconZap"><Path d="M13.9984 2.08611C13.9984 1.1084 12.7399 0.711686 12.1792 1.51265L3.13954 14.4265C2.67559 15.0892 3.14975 15.9999 3.95877 15.9999H9.99844V21.9137C9.99844 22.8915 11.257 23.2882 11.8177 22.4872L20.8573 9.57339C21.3213 8.91062 20.8471 7.99993 20.0381 7.99993H13.9984V2.08611Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZap;
